export const semantic = {
  breakpoint: {
    mobile: "1024px",
    laptop: "1280px",
    desktop: "1440px",
  },
  container: {
    control: "250px",
    overlay: "900px",
    confirm: "460px",
  },
  // focusRing: {
  //   width: "1px",
  //   style: "solid",
  //   color: "{primary.default}",
  //   offset: "2px",
  //   shadow: "none",
  // },
  disabledOpacity: "0.6",
  iconSize: "{content.font.size}",
  // anchorGutter: "2px",
  transitionDuration: "250ms",
  transitionEasing: "cubic-bezier(0.4, 0, 0.2, 1)",
  content: {
    fontFamily: "Inter, sans-serif",
    fontSize: "{typography.body.text.regular.font.size}",
    fontLeading: "{typography.body.text.regular.font.leading}",
    fontWeight: "{typography.body.text.regular.font.weight}",
    borderRadius: "{border.radius.6}",
  },
  typography: {
    pageHeading: {
      fontSize: "36px",
      fontLeading: "48px",
      fontWeight: "600",
      color: "{text.heading}",
    },
    mobilePageHeading: {
      fontSize: "24px",
      fontLeading: "36px",
      fontWeight: "600",
      color: "{text.heading}",
    },
    sectionHeading: {
      fontSize: "28px",
      fontLeading: "40px",
      fontWeight: "600",
      color: "{text.heading}",
    },
    cardHeading: {
      fontSize: "20px",
      fontLeading: "32px",
      fontWeight: "500",
      color: "{text.heading}",
    },
    accordionHeading: {
      fontSize: "16px",
      fontLeading: "20px",
      fontWeight: "500",
      color: "{text.heading}",
    },
    tableHeading: {
      fontSize: "16px",
      fontLeading: "20px",
      fontWeight: "500",
      color: "{text.heading}",
    },
    mobileTableHeading: {
      fontSize: "14px",
      fontLeading: "24px",
      fontWeight: "600",
      color: "{text.heading}",
    },
    bodyTextRegular: {
      fontSize: "14px",
      fontLeading: "20px",
      fontWeight: "400",
      color: "{text.body}",
    },
    mobileBodyTextRegular: {
      fontSize: "12px",
      fontLeading: "16px",
      fontWeight: "400",
      color: "{text.body}",
    },
    bodyTextLink: {
      fontSize: "14px",
      fontLeading: "20px",
      fontWeight: "500",
      color: "{primary.support}",
    },
    bodyTextSemibold: {
      fontSize: "14px",
      fontLeading: "20px",
      fontWeight: "600",
      color: "{text.body}",
    },
    captionTextRegular: {
      fontSize: "12px",
      fontLeading: "16px",
      fontWeight: "400",
      color: "{text.caption}",
    },
    captionTextSemibold: {
      fontSize: "12px",
      fontLeading: "16px",
      fontWeight: "600",
      color: "{text.caption}",
    },
    subtleTextRegular: {
      fontSize: "10px",
      fontLeading: "12px",
      fontWeight: "400",
      color: "{text.caption}",
    },
    subtleTextSemibold: {
      fontSize: "10px",
      fontLeading: "12px",
      fontWeight: "600",
      color: "{text.caption}",
    },
    inputRegular: {
      fontSize: "14px",
      fontLeading: "16px",
      fontWeight: "400",
      color: "{text.input-text}",
    },
    inputPlaceholder: {
      fontSize: "14px",
      fontLeading: "16px",
      fontWeight: "400",
      color: "{text.input-placeholder}",
    },
    inputLabel: {
      fontSize: "10px",
      fontLeading: "12px",
      fontWeight: "500",
      color: "{text.input-label}",
    },
  },
  formField: {
    paddingX: "{padding.10}",
    paddingY: "{padding.8}",
    fontSize: "{typography.input.regular.font.size}",
    fontLeading: "{typography.input.regular.font.leading}",
    sm: {
      fontSize: "12px",
      fontLeading: "100%",
      paddingX: "{padding.4}",
      paddingY: "{padding.4}",
    },
    lg: {
      fontSize: "{form.field.font.size}",
      fontLeading: "{form.field.font.leading}",
      paddingX: "{padding.16}",
      paddingY: "{padding.12}",
    },
    borderRadius: "{border.radius.6}",
    focusRing: {
      width: "0",
      style: "none",
      color: "transparent",
      offset: "0",
      shadow: "none",
    },
    transitionDuration: "{transition.duration}",
    iconSize: "34px",
  },
  list: {
    padding: "0",
    gap: "0",
    header: {
      padding: "{padding.8} {padding.12}",
    },
    option: {
      padding: "{padding.8} {padding.12}",
      borderRadius: "0",
    },
    optionGroup: {
      padding: "{padding.8} {padding.12} 0 {padding.12}",
      fontWeight: "500",
    },
  },
  mask: {
    transitionDuration: "{transition.duration}",
  },
  navigation: {
    list: {
      padding: "0",
      gap: "0",
    },
    item: {
      padding: "{padding.8} {padding.12}",
      borderRadius: "0",
      gap: "{gap.8}",
    },
    submenuLabel: {
      padding: "{navigation.item.padding}",
      fontWeight: "inherit",
    },
    submenuIcon: {
      size: "{icon.size}",
    },
  },
  overlay: {
    select: {
      borderRadius: "{border.radius.8}",
      shadow: "0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0px 8px 10px -6px rgba(0, 0, 0, 0.10)",
    },
    popover: {
      borderRadius: "{border.radius.8}",
      padding: "{padding.16}",
      shadow: "0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0px 8px 10px -6px rgba(0, 0, 0, 0.10)",
    },
    modal: {
      borderRadius: "{border.radius.12}",
      padding: "{padding.16}",
      shadow: "0px 20px 25px -5px rgba(0, 0, 0, 0.10), 0px 8px 10px -6px rgba(0, 0, 0, 0.10)",
    },
    navigation: {
      shadow: "0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)",
    },
  },
  colorScheme: {
    light: {
      gradient:
        "linear-gradient(136deg, rgba(255, 239, 218, 1) 30.07%, rgba(212, 255, 244, 1) 88.29%), {surface.bg-white}",
      surface: {
        "bg-white": "{color.white}",
        "bg-grey": "{color.gray.50}",
        "bg-grey-contrast": "{color.gray.100}",
        border: "{color.gray.200}",
        "border-selected": "{primary.support}",
        "border-danger": "{danger.default}",
        "border-warning": "{warning.highlight}",
        "border-secondary": "{color.gray.400}",
        "border-info": "{color.blue.200}",
        "border-input": "{color.gray.300}",
        "bg-dim": "{color.black-transparent}",
        "bg-dim-white": "{color.white-transparent}",
      },
      text: {
        heading: "{color.gray.900}",
        body: "{color.gray.900}",
        caption: "{color.gray.500}",
        "subtle-text": "{color.gray.400}",
        "button-secondary": "{color.gray.900}",
        "button-primary": "{color.white}",
        "input-placeholder": "{color.gray.400}",
        "input-text": "{color.gray.900}",
        "input-label": "{color.gray.500}",
        "input-icon": "{color.gray.400}",
      },
      content: {
        background: "{surface.bg-white}",
        hoverBackground: "{primary.background}",
        borderColor: "{surface.border}",
        color: "{typography.body.text.regular.color}",
        hoverColor: "{primary.support}",
      },
      plain: {
        default: "{color.gray.700}",
        support: "{color.gray.200}",
      },
      highlight: {
        default: "{color.brand-orange.500}",
        support: "{color.brand-orange.100}",
        background: "{primary.support}",
        // color: "{color.gray.900}",
      },
      primary: {
        default: "{color.brand-green.500}",
        support: "{color.brand-green.450}",
        disabled: "{color.brand-green.300}",
        background: "{color.brand-green.50}",
        hover: "{color.brand-green.600}",
        active: "{color.brand-green.700}",
      },
      success: {
        default: "{color.green.700}",
        support: "{color.green.100}",
        border: "{color.green.200}",
      },
      danger: {
        default: "{color.red.600}",
        support: "{color.red.100}",
        text: "{danger.default}",
        disabled: "{color.red.300}",
        border: "{color.red.200}",
      },
      warning: {
        default: "{color.orange.700}",
        highlight: "{color.orange.600}",
        support: "{color.orange.100}",
        border: "{color.orange.200}",
      },
      "warning-soft": {
        default: "{color.yellow.700}",
        highlight: "{color.yellow.600}",
        support: "{color.yellow.100}",
        border: "{color.yellow.200}",
      },
      info: {
        default: "{color.blue.700}",
        support: "{color.blue.100}",
        border: "{color.blue.200}",
      },
      formField: {
        background: "{surface.bg-white}",
        disabledBackground: "{surface.bg-grey}",
        filledBackground: "{surface.bg-white}",
        filledHoverBackground: "{surface.bg-white}",
        filledFocusBackground: "{surface.bg-white}",
        borderColor: "{surface.border-input}",
        hoverBorderColor: "{primary.support}",
        focusBorderColor: "{primary.default}",
        invalidBorderColor: "{danger.default}",
        color: "{text.input-text}",
        disabledColor: "{text.input-placeholder}",
        placeholderColor: "{text.input-placeholder}",
        invalidPlaceholderColor: "{danger.default}",
        // floatLabelColor: "{surface.500}",
        // floatLabelFocusColor: "{primary.600}",
        // floatLabelActiveColor: "{surface.500}",
        floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
        iconColor: "{text.input-icon}",
        shadow: "0px 1px 2px 0px rgba(18, 18, 23, 0.05)",
      },
      list: {
        option: {
          focusBackground: "{content.hover.background}",
          selectedBackground: "{content.hover.background}",
          selectedFocusBackground: "{content.hover.background}",
          color: "{content.color}",
          focusColor: "{content.hover.color}",
          selectedColor: "{content.hover.color}",
          selectedFocusColor: "{content.hover.color}",
          icon: {
            color: "{content.color}",
            focusColor: "{content.hover.color}",
          },
        },
        optionGroup: {
          background: "transparent",
          color: "{text.caption}",
        },
      },
      mask: {
        background: "rgba(0,0,0,0.4)",
        color: "{text.body}",
      },
      navigation: {
        item: {
          focusBackground: "{content.hover.background}",
          activeBackground: "{content.hover.background}",
          color: "{text.body}",
          focusColor: "{content.hover.color}",
          activeColor: "{content.hover.color}",
          icon: {
            color: "{color.neutral.400}",
            focusColor: "{content.hover.color}",
            activeColor: "{content.hover.color}",
          },
        },
        submenuLabel: {
          background: "transparent",
          color: "{navigation.item.color}",
        },
        submenuIcon: {
          color: "{navigation.item.icon.color}",
          focusColor: "{navigation.item.icon.focus.color}",
          activeColor: "{navigation.item.icon.active.color}",
        },
      },
      overlay: {
        select: {
          background: "{surface.bg-white}",
          borderColor: "{surface.border}",
          color: "{text.input-text}",
        },
        popover: {
          background: "{surface.bg-white}",
          borderColor: "{surface.border}",
          color: "{text.input-text}",
        },
        modal: {
          background: "{surface.bg-white}",
          borderColor: "{surface.border}",
          color: "{text.input-text}",
        },
      },
    },
    dark: {
      gradient:
        "linear-gradient(136deg, rgba(255, 239, 218, 0.20) 30.07%, rgba(212, 255, 244, 0.20) 88.29%), {surface.bg-white}",
      surface: {
        "bg-white": "{color.gray.900}",
        "bg-grey": "{color.gray.800}",
        "bg-grey-contrast": "{color.gray.700}",
        border: "{color.gray.600}",
        "border-selected": "{primary.support}",
        "border-danger": "{danger.default}",
        "border-warning": "{warning.highlight}",
        "border-info": "{color.blue.200}",
        "border-input": "{color.gray.500}",
        "bg-dim": "{color.black-transparent}",
        "bg-dim-white": "{color.white-transparent}",
      },
      text: {
        heading: "{color.gray.50}",
        body: "{color.gray.50}",
        caption: "{color.gray.400}",
        "subtle-text": "{color.gray.500}",
        "button-secondary": "{color.gray.50}",
        "button-primary": "{color.white}",
        "input-placeholder": "{color.gray.500}",
        "input-text": "{color.gray.50}",
        "input-label": "{color.gray.400}",
        "input-icon": "{color.gray.500}",
      },
      content: {
        background: "{surface.bg-white}",
        hoverBackground: "{primary.background}",
        borderColor: "{surface.border}",
        color: "{typography.body.text.regular.color}",
        hoverColor: "{primary.default}",
      },
      plain: {
        default: "{color.gray.50}",
        support: "{color.gray.200}",
      },
      highlight: {
        default: "{color.brand-orange.400}",
        support: "{color.brand-orange.600}",
        // background: "{primary.support}",
        // color: "{color.gray.900}",
      },
      primary: {
        default: "{color.brand-green.50}",
        support: "{color.brand-green.500}",
        disabled: "{color.brand-green.300}",
        background: "{color.brand-green.600}",
        hover: "{color.brand-green.600}",
        active: "{color.brand-green.700}",
      },
      success: {
        default: "{color.green.50}",
        support: "{color.green.700}",
        border: "{color.green.600}",
      },
      danger: {
        default: "{color.red.200}",
        support: "{color.red.700}",
        text: "{danger.default}",
        disabled: "{color.red.600}",
        border: "{color.red.600}",
      },
      warning: {
        default: "{color.orange.50}",
        support: "{color.orange.700}",
        highlight: "{color.orange.600}",
        border: "{color.orange.600}",
      },
      "warning-soft": {
        default: "{color.yellow.50}",
        support: "{color.yellow.700}",
        highlight: "{color.yellow.600}",
        border: "{color.yellow.600}",
      },
      info: {
        default: "{color.blue.50}",
        support: "{color.blue.600}",
        border: "{color.blue.500}",
      },
      formField: {
        background: "{surface.bg-white}",
        disabledBackground: "{surface.bg-grey}",
        filledBackground: "{surface.bg-white}",
        filledHoverBackground: "{surface.bg-white}",
        filledFocusBackground: "{surface.bg-white}",
        borderColor: "{surface.border-input}",
        hoverBorderColor: "{primary.support}",
        focusBorderColor: "{primary.default}",
        invalidBorderColor: "{danger.default}",
        color: "{text.input-text}",
        disabledColor: "{text.input-placeholder}",
        placeholderColor: "{text.input-placeholder}",
        invalidPlaceholderColor: "{danger.default}",
        // floatLabelColor: "{surface.500}",
        // floatLabelFocusColor: "{primary.600}",
        // floatLabelActiveColor: "{surface.500}",
        floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
        iconColor: "{text.input-icon}",
        shadow: "0px 1px 2px 0px rgba(18, 18, 23, 0.05)",
      },
      list: {
        option: {
          focusBackground: "{content.hover.background}",
          selectedBackground: "{content.hover.background}",
          selectedFocusBackground: "{content.hover.background}",
          color: "{content.color}",
          focusColor: "{content.hover.color}",
          selectedColor: "{content.hover.color}",
          selectedFocusColor: "{content.hover.color}",
          icon: {
            color: "{content.color}",
            focusColor: "{content.hover.color}",
          },
        },
        optionGroup: {
          background: "transparent",
          color: "{text.caption}",
        },
      },
      mask: {
        background: "rgba(0,0,0,0.4)",
        color: "{text.body}",
      },
      navigation: {
        item: {
          focusBackground: "{content.hover.background}",
          activeBackground: "{content.hover.background}",
          color: "{text.body}",
          focusColor: "{content.hover.color}",
          activeColor: "{content.hover.color}",
          icon: {
            color: "{color.neutral.400}",
            focusColor: "{content.hover.color}",
            activeColor: "{content.hover.color}",
          },
        },
        submenuLabel: {
          background: "transparent",
          color: "{navigation.item.color}",
        },
        submenuIcon: {
          color: "{navigation.item.icon.color}",
          focusColor: "{navigation.item.icon.focus.color}",
          activeColor: "{navigation.item.icon.active.color}",
        },
      },
      overlay: {
        select: {
          background: "{surface.bg-white}",
          borderColor: "{surface.border}",
          color: "{text.input-text}",
        },
        popover: {
          background: "{surface.bg-white}",
          borderColor: "{surface.border}",
          color: "{text.input-text}",
        },
        modal: {
          background: "{surface.bg-white}",
          borderColor: "{surface.border}",
          color: "{text.input-text}",
        },
      },
    },
  },
};
